module.exports = __webpack_public_path__ + "r-v3/img/man-01.3ce6a017.png";